import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class CompanyConfigurationCompanyActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Base/Company/CompanyBrowser")
	}

	render() {
		return (
			<Activity 
				name="CompanyConfigurationCompany"
				RenderedComponent={this.RenderedComponent}
				context="CompanyConfigurationCompany"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(CompanyConfigurationCompanyActivity)
